<div id="button">
  <div id="button_bottom">
  <div id="wenzi"><span *ngIf="text">{{text}}</span><span *ngIf="!text">滑动开启测验</span></div>
  <div id="button_top"></div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/slide-button/slide-button.component.html